import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

/** Enterprise screens under `/enterprise/...` (default: `enterprise/enterprise`). */
export const companyRoutes: Route = {
    path: 'enterprise',
    data: { title: 'enterprise' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'enterprise' },
        {
            path: 'enterprise',
            loadComponent: () =>
                import('./enterprise/enterprise.component').then((m) => m.EnterpriseComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'enterprise' },
        },
        {
            path: 'enterprise-user',
            loadComponent: () =>
                import('./enterprise-user/enterprise-user.component').then((m) => m.EnterpriseUserComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'enterprise-user' },
        },
    ],
};
